import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { imgUrl } from "@/lib/api";

export function Gallery({ images }) {
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" className="px-5 py-16 scroll-mt-16">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <Overline>Moments</Overline>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-primary mt-3">From our events</h2>
        </Reveal>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 gap-2 sm:gap-3">
          {images.map((img, i) => (
            <Reveal key={img.id} delay={(i % 4) * 0.05}>
              <button
                data-testid={`gallery-item-${i}`}
                onClick={() => setActive(img)}
                className="block w-full aspect-square overflow-hidden rounded-2xl group"
              >
                <img
                  src={imgUrl(img.storage_path)}
                  alt={img.caption || "Event"}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-active:scale-105"
                />
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            data-testid="lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
            className="fixed inset-0 z-[60] bg-black/90 grid place-items-center p-4"
          >
            <button
              data-testid="lightbox-close"
              onClick={() => setActive(null)}
              className="absolute top-5 right-5 grid place-items-center w-11 h-11 rounded-full bg-white/15 text-white"
            >
              <X className="w-5 h-5" />
            </button>
            <motion.img
              initial={{ scale: 0.92 }}
              animate={{ scale: 1 }}
              src={imgUrl(active.storage_path)}
              alt={active.caption}
              className="max-w-full max-h-[80vh] rounded-2xl object-contain"
              onClick={(e) => e.stopPropagation()}
            />
            {active.caption && (
              <p className="absolute bottom-6 inset-x-0 text-center text-white/80 text-sm">{active.caption}</p>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
